import React from 'react';

import { Image } from 'app/shared/ui';

import { GridItem } from '../GridContainer';

import { GridContainerSt } from './index.css';

export const AboutCarSale24 = (): JSX.Element => (
  <GridContainerSt>
    <GridItem gridRow={1} columns={[8, 5]} mb={28}>
      <Image
        src="/assets/tradein/carsale24/cs24-logo.png"
        alt="carsale24-logo"
        width={166}
        height={28}
      />
    </GridItem>
    <GridItem gridRow={[2, 1]} columns={[12, 7]} columnStart={[1, 6]}>
      <p style={{ margin: 0 }}>
        carsale24 wurde 2010 in Köln gegründet und wird heute an Standorten in
        Nordrhein-Westfalen und Hamburg betrieben. Das Unternehmen verfolgen das
        Ziel, den Autoverkauf online so bequem und sicher wie möglich zu
        gestalten und dabei den bestmöglichen Preis zu erzielen.
      </p>
    </GridItem>
  </GridContainerSt>
);
